import { NullQ } from "@pdfking/structs"
import type { Atom, GUID } from "@pdfking/tfunc"

// A monotonic marker — e.g. `PdfviewState.revision`, cheap to compare (`===`,
// no re-encoding a whole input) to recognize a route echo. The counter is
// module-private and shared by every caller; only monotonicity (never reuse)
// matters, not which viewer instance issued a given value.
let counter = 0n

export const NewId = (): GUID => ++counter as GUID

// Deterministic id for a single atomic value — the same input always yields
// the same GUID, minted once on first sight and memoized thereafter.
const unique_ids = new Map<Atom, GUID>()

export const UniqueId = (s: Atom): GUID => {
  const id = unique_ids.get(s)
  if (NullQ(id)) {
    const fresh = NewId()
    unique_ids.set(s, fresh)
    return fresh
  }
  return id
}
